import CreateGroupForm from "@/components/CreateGroupForm"

export default function AdminCreateGroupPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <h1 className="text-2xl font-bold mb-6">Admin: Create Group / Sub-group</h1>
      <CreateGroupForm />
    </div>
  )
}
